import React from 'react';

import { Box, Typography } from '@mui/material';

import { SxProp } from 'src/types/mui';

type DashboardChartWrapperProps = {
  isPrintView?: boolean;
  isDatasetEmpty?: boolean;
  wrapperHeight?: number;
  wrapperWidth?: number;
  topMargin?: number;
};

export const DashboardChartWrapper: React.FC<
  React.PropsWithChildren<DashboardChartWrapperProps>
> = ({ children, isPrintView, isDatasetEmpty, wrapperHeight, wrapperWidth = 1000, topMargin }) => {
  return (
    <Box
      height={wrapperHeight || '100%'}
      marginTop={topMargin}
      overflow="hidden"
      width={isPrintView ? wrapperWidth : undefined}
    >
      {isDatasetEmpty ? (
        <Box sx={noDataBoxStyles}>
          <Typography variant="body1" color="text.secondary">
            {'No data to present\n Try to select different filters'}
          </Typography>
        </Box>
      ) : (
        children
      )}
    </Box>
  );
};

const noDataBoxStyles: SxProp = {
  display: 'flex',
  alignItems: 'center',
  verticalAlign: 'middle',
  justifyContent: 'center',
  height: '100%',
  overflow: 'hidden',

  p: {
    textAlign: 'center',
    whiteSpace: 'pre-line',
  },
};
